/**
 * Environments where not-yet-released features are shown.
 * Fail-closed: any other REACT_APP_ENVIRONMENT value (including `production`) hides them.
 * Unset = dev previews and plain local runs.
 */
const PRE_RELEASE_ENVIRONMENTS = ['local', 'development', 'staging'];

const isPreReleaseEnvironment = (
  environment: string | undefined = process.env.REACT_APP_ENVIRONMENT,
): boolean => !environment || PRE_RELEASE_ENVIRONMENTS.includes(environment);

/** Salon gacha tickets on My Page (#2770). Hidden in production until release. */
const SHOW_SALON_GACHA_TICKETS = isPreReleaseEnvironment();

export { isPreReleaseEnvironment, SHOW_SALON_GACHA_TICKETS };
